import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { jamboCareLogo, searchIcon } from "../../../assets";
import CloseIcon from "@mui/icons-material/Close";
import { pages } from "../../../utils/header-links/tabLinks";
import EventEHRLazyDropdown from "../../Molecules/lazy-loading-search/EventEHRLazyLoadingSearch";
import FacilityDropdown from "../../Molecules/facility-dropdown/FacilityDropdown";
interface EventEHRSmallScreenMenuDrawerProps {
  open: boolean;
  searchFieldData?: any;

  dropdownOptions?: any;
  dropdownSearch: any;
  selectedValue: any;
  setDropdownSearch: any;
  setPageCount: (data: any) => void;
  setResetFlag: (data: any) => void;
  setSelectedValue: (data: any) => void;

  handleMenuItem?: (event: any) => void;
  handleCloseDrawer?: () => void;
  handleSearchChangeValue?: (event: any) => void;
  handleSelectedSearchValue?: (event: any) => void;
  handleSwitchToAdmin?: () => void;
  showSwitchToProvider?: boolean;
}

export default function EventEHRSmallScreenMenuDrawer({
  open,
  dropdownOptions,
  dropdownSearch,
  selectedValue,
  setDropdownSearch,
  setPageCount,
  setResetFlag,
  setSelectedValue,
  handleMenuItem,
  handleCloseDrawer,
  handleSwitchToAdmin,
  showSwitchToProvider = false,
}: EventEHRSmallScreenMenuDrawerProps) {
  const path = window.location.pathname.split("/")[1];
  const [selectedPage, setSelectedPage] = React.useState<string>(
    path ? path?.charAt(0)?.toUpperCase() + path?.slice(1) : "Dashboard",
  ); // Track selected page

  const toggleDrawer = (e: any) => () => {
    e.stopPropagation();
    e.preventDefault();
    handleCloseDrawer && handleCloseDrawer();
  };

  React.useEffect(() => {
    setSelectedPage(
      path ? path?.charAt(0)?.toUpperCase() + path?.slice(1) : "Dashboard",
    );
  }, [path]);

  const DrawerList = (
    <Box
      sx={{ width: 300 }}
      role="presentation"
      onClick={(e) => toggleDrawer(e)}
    >
      <div className="mt-6 ml-4 mr-4 flex flex-col justify-start">
        <CloseIcon
          className="self-end cursor-pointer"
          onClick={() => handleCloseDrawer && handleCloseDrawer()}
        />
        <img
          src={jamboCareLogo}
          className="mb-6"
          alt="logo"
          style={{ height: "40px" }}
        />
        {/* Search for small screen */}
        <Box
          sx={{
            // flexGrow: 1,
            display: {
              xs: "flex",
              sm: "flex",
              md: "flex",
            },
          }}
        >
          <EventEHRLazyDropdown
            clearSearch={true}
            placeholder="Search"
            fullWidth={"100%"}
            startIcon={
              <img
                alt="search-icon"
                src={searchIcon}
                width={"24px"}
                height={"24px"}
              />
            }
            dropdownOptions={dropdownOptions}
            dropdownSearch={dropdownSearch}
            selectedValue={selectedValue}
            setDropdownSearch={setDropdownSearch}
            setPageCount={(data) => {
              setPageCount(data);
            }}
            setResetFlag={(data) => {
              setResetFlag(data);
            }}
            setSelectedValue={(data) => {
              setSelectedValue(data);
            }}
          />
        </Box>

        {/* Switch to Provider dropdown for small screens */}
        {showSwitchToProvider && (
          <Box sx={{ marginTop: "16px", marginBottom: "16px" }}>
            <FacilityDropdown
              variant="mobile"
              showDropdown={false} // Direct redirect without dropdown
              onFacilitySelect={(facility) => {
                console.log("Selected facility:", facility);
                handleCloseDrawer && handleCloseDrawer();
              }}
            />
          </Box>
        )}
      </div>
      <List>
        {pages.map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton
              onClick={() => handleMenuItem && handleMenuItem(text)}
              sx={{
                background: text === selectedPage ? "#005596" : "",
                color: text === selectedPage ? "white" : "", // Set color dynamically
                "&:hover": {
                  background: text === selectedPage ? "#003d70" : "#f0f0f0", // Hover background
                  color: text === selectedPage ? "white" : "black", // Hover text color
                },
              }}
            >
              <ListItemText
                primary={
                  text === "Contact-directory"
                    ? "Contact Directory"
                    : text === "Unsigned-visits"
                      ? "Unsigned Visits"
                      : text
                }
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      <Drawer open={open} onClose={(e) => toggleDrawer(e)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
